// Copyright 2024 - MinIO, Inc. All rights reserved.
import { createAsyncThunk } from "@reduxjs/toolkit";
import { obsApi } from "../../../api";
import { ClusterAnalysis } from "../../DataMap/types";
import { ApiError } from "../../../api/observeApi";

export const getHealthAsync = createAsyncThunk(
  "healing/getHealthAsync",
  async (_, { rejectWithValue }) => {
    return obsApi.xRay
      .xRayHealth()
      .then((res) => {
        return res.data as ClusterAnalysis;
      })
      .catch((res) => {
        return rejectWithValue(res.error as ApiError);
      });
  },
);
